import React from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { MessageCircle, Mail } from "lucide-react";

interface ContactDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

/**
 * Reusable "Échanger avec moi" contact dialog with SMS + Email options.
 */
export const ContactDialog: React.FC<ContactDialogProps> = ({ open, onOpenChange }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="text-2xl font-cinzel text-primary">
            Échanger avec moi
          </DialogTitle>
          <DialogDescription className="font-montserrat">
            Choisissez votre mode de contact préféré
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <a
            href="sms:+33637031866"
            className="flex items-center gap-4 p-4 rounded-lg border border-border hover:bg-muted/50 transition-colors"
          >
            <div className="w-12 h-12 bg-primary-light rounded-lg flex items-center justify-center text-primary flex-shrink-0">
              <MessageCircle className="w-6 h-6" />
            </div>
            <div>
              <p className="font-semibold text-primary font-montserrat">Par sms</p>
              <p className="text-sm text-muted-foreground font-montserrat">06 37 03 18 66</p>
            </div>
          </a>
          <a
            href="mailto:contact@regard-de-nature.fr"
            className="flex items-center gap-4 p-4 rounded-lg border border-border hover:bg-muted/50 transition-colors"
          >
            <div className="w-12 h-12 bg-secondary-light rounded-lg flex items-center justify-center text-secondary flex-shrink-0">
              <Mail className="w-6 h-6" />
            </div>
            <div>
              <p className="font-semibold text-primary font-montserrat">Par email</p>
              <p className="text-sm text-muted-foreground font-montserrat">
                contact@regard-de-nature.fr
              </p>
            </div>
          </a>
        </div>
      </DialogContent>
    </Dialog>
  );
};
